<template>
  <div class="book-search-results-list autosuggest-results-list">
    <ul class="book-search-results-list__suggestion-list">
      <li v-for="(item, i) in data.results" :key="i">
        <div
          class="book-search-results-list__autosuggest-result"
          :data-test="`search-result-${item.external_id}`"
          @mousedown="openLink(item.external_id)"
        >
          <!-- eslint-disable-next-line vue/no-v-html -->
          <img
            class="book-search-results-list__result-image"
            :src="item.images[0]"
            width="60"
            :alt="`Copertina di ${item.title}`"
          />
          <div class="book-search-results-list__result-info">
            <div class="dea-heading--regular__m" :data-test="`search-result-title-${item.external_id}`">
              {{ item.title }}
            </div>
            <div class="book-search-results-list__subjects-list">
              <div v-for="(subject, index) in item.subjects" :key="subject.id" class="dea-heading--regular__ms">
                {{ subject.name }}<template v-if="index < item.subjects.length - 1">,</template>
              </div>
            </div>
            <div class="dea-heading--regular__ms book-search-results-list__result-brand">{{ item.brand.name }}</div>
            <br />
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "BookSearchList",

  props: {
    data: {
      type: Object,
      default: () => {},
    },
    config: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openLink(link) {
      window.open(this.config.linkBase.replace("%(book)s", link), this.config.linkTarget);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";
$autosuggest-h: 360px;

.book-search-results-list {
  padding: $space-base;

  &__suggestion-list {
    list-style: none;
    max-height: $autosuggest-h;
    overflow-y: auto;
    padding: 0;

    li {
      margin-bottom: $space-base;
    }
  }

  &__autosuggest-result {
    cursor: pointer;
    display: flex;
  }

  &__result-info {
    margin-left: $space-x-small;
  }

  &__result-image {
    align-self: flex-start;
  }

  &__subjects-list {
    margin: $space-x-small 0;
  }

  &__result-brand {
    text-transform: uppercase;
  }
}
</style>
